/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventSlot,
  FleetEventSlotCreateInput,
  FleetEventSlotSortInput,
  FleetEventSlotUpdateInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create event slot
 */
export const createFleetEventSlot = (
    fleetEventSlotCreateInput: MaybeRefOrGetter<FleetEventSlotCreateInput>,
 signal?: AbortSignal
) => {
      fleetEventSlotCreateInput = toValue(fleetEventSlotCreateInput);

      return axiosClient<FleetEventSlot>(
      {url: `/fleet-event-slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSlotCreateInput, signal
    },
      );
    }




export const getCreateFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,CreateFleetEventSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,CreateFleetEventSlotMutationVariables, TContext> => {

const mutationKey = ['createFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventSlot>>, CreateFleetEventSlotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFleetEventSlot(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventSlot>>>
    export type CreateFleetEventSlotMutationBody = FleetEventSlotCreateInput
    export type CreateFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetEventSlotMutationVariables = {data: FleetEventSlotCreateInput}

    /**
 * @summary Create event slot
 */
export const useCreateFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventSlot>>, TError,CreateFleetEventSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventSlot>>,
        TError,
        CreateFleetEventSlotMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort event slots
 */
export const sortFleetEventSlots = (
    fleetEventSlotSortInput: MaybeRefOrGetter<FleetEventSlotSortInput>,
 signal?: AbortSignal
) => {
      fleetEventSlotSortInput = toValue(fleetEventSlotSortInput);

      return axiosClient<void>(
      {url: `/fleet-event-slots/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSlotSortInput, signal
    },
      );
    }




export const getSortFleetEventSlotsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,SortFleetEventSlotsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,SortFleetEventSlotsMutationVariables, TContext> => {

const mutationKey = ['sortFleetEventSlots'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortFleetEventSlots>>, SortFleetEventSlotsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sortFleetEventSlots(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortFleetEventSlotsMutationResult = NonNullable<Awaited<ReturnType<typeof sortFleetEventSlots>>>
    export type SortFleetEventSlotsMutationBody = FleetEventSlotSortInput
    export type SortFleetEventSlotsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SortFleetEventSlotsMutationVariables = {data: FleetEventSlotSortInput}

    /**
 * @summary Sort event slots
 */
export const useSortFleetEventSlots = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventSlots>>, TError,SortFleetEventSlotsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortFleetEventSlots>>,
        TError,
        SortFleetEventSlotsMutationVariables,
        TContext
      > => {
      return useMutation(getSortFleetEventSlotsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update event slot
 */
export const updateFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
    fleetEventSlotUpdateInput: MaybeRefOrGetter<FleetEventSlotUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSlotUpdateInput = toValue(fleetEventSlotUpdateInput);

      return axiosClient<FleetEventSlot>(
      {url: `/fleet-event-slots/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSlotUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,UpdateFleetEventSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,UpdateFleetEventSlotMutationVariables, TContext> => {

const mutationKey = ['updateFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventSlot>>, UpdateFleetEventSlotMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetEventSlot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventSlot>>>
    export type UpdateFleetEventSlotMutationBody = FleetEventSlotUpdateInput
    export type UpdateFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetEventSlotMutationVariables = {id: string;data: FleetEventSlotUpdateInput}

    /**
 * @summary Update event slot
 */
export const useUpdateFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSlot>>, TError,UpdateFleetEventSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventSlot>>,
        TError,
        UpdateFleetEventSlotMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy event slot
 */
export const destroyFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-slots/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,DestroyFleetEventSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,DestroyFleetEventSlotMutationVariables, TContext> => {

const mutationKey = ['destroyFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventSlot>>, DestroyFleetEventSlotMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyFleetEventSlot(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventSlot>>>

    export type DestroyFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetEventSlotMutationVariables = {id: string}

    /**
 * @summary Destroy event slot
 */
export const useDestroyFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSlot>>, TError,DestroyFleetEventSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventSlot>>,
        TError,
        DestroyFleetEventSlotMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetEventSlotMutationOptions(options), queryClient);
    }
